import { Column, flexRender, HeaderGroup } from '@tanstack/react-table';
import React from 'react';

import { Tooltip } from '../../tooltip/Tooltip';
import { StickyTableHeader } from '../sticky-table-header/StickyTableHeader';
import { PinConfig } from '../table-cell/TableCell';
import { TableHeader } from '../table-header/TableHeader';
import { getCellAlignment } from './TableV2';
import { TableColumns, TableRow } from './TableV2.types';

const isTableColumns = (value: unknown): value is TableColumns => {
  return typeof value === 'object' && value !== null && 'type' in value;
};

interface TableV2HeaderProps {
  getPinConfig: (column: Column<TableRow>) => PinConfig | undefined;
  stickyHeader?: boolean;
  headerGroup: HeaderGroup<TableRow>;
}

export const TableV2Header = ({
  getPinConfig,
  stickyHeader,
  headerGroup,
}: TableV2HeaderProps) => {
  return (
    <tr key={headerGroup.id}>
      {headerGroup.headers.map(header => {
        const content = flexRender(
          header.column.columnDef.header,
          header.getContext()
        );
        const meta = header.column.columnDef.meta;
        const isValid = isTableColumns(meta);
        const pinConfig = getPinConfig(header.column);

        if (!isValid) {
          return null;
        }

        const children =
          stickyHeader || pinConfig ? (
            <StickyTableHeader
              alignment={meta?.type && getCellAlignment(meta.type)}
              pinConfig={pinConfig}
            >
              {content}
            </StickyTableHeader>
          ) : (
            <TableHeader
              alignment={meta?.type && getCellAlignment(meta.type)}
              key={header.column.id}
            >
              {content}
            </TableHeader>
          );

        return meta?.tooltip ? (
          <Tooltip inPortal label={meta?.tooltip}>
            {children}
          </Tooltip>
        ) : (
          children
        );
      })}
    </tr>
  );
};
